import { EditIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { useState } from 'react';
import GrantTeamPermissionsModal from 'zComponents/molecules/GrantTeamPermissionsModal';

import { Button, Col, Row, Tooltip } from 'zui/Antd';

const PermissionsPanelExtra = ({ teamID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const canManage = useManagePermittedRoles('aCPermissionManagement');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	const [openModal, setOpenModal] = useState(false);

	const handleOpenModal = (e) => {
		e.stopPropagation();
		if (!canManage) return;
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('permissions')) {
			setActiveKeys([...activeKeys, 'permissions']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('permissions')) {
					return [...prev, 'permissions'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Tooltip title={!canManage ? permissionDeniedMessage : ''}>
					<span>
						<Button
							type='text'
							size='small'
							icon={<EditIcon color='currentColor' />}
							onClick={handleOpenModal}
							disabled={!canManage}
						/>
					</span>
				</Tooltip>
			</Col>
			<GrantTeamPermissionsModal visible={openModal} setVisible={handleCloseModal} teamID={teamID}>
				<div />
			</GrantTeamPermissionsModal>
		</Row>
	);
};

export default PermissionsPanelExtra;
